const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const log = require('../../util/log');
const cast = require('../../util/cast');
const formatMessage = require('format-message');
const DAPjs = require('../../../../scratch-gui-develop/node_modules/dapjs');
const microbitUniversalHex = require('../../../../scratch-gui-develop/node_modules/@microbit/microbit-universal-hex');

const blockIconURI = 'data:image/svg+xml;base64,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';
const menuIconURI = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48cmVjdCB4PSI0IiB5PSI3IiB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHJ4PSI3IiBmaWxsPSJub25lIiBzdHJva2U9IiMxMTEiIHN0cm9rZS13aWR0aD0iMi41Ii8+PGNpcmNsZSBjeD0iMTEiIGN5PSIxNiIgcj0iMiIgZmlsbD0iIzExMSIvPjxjaXJjbGUgY3g9IjIxIiBjeT0iMTYiIHI9IjIiIGZpbGw9IiMxMTEiLz48L3N2Zz4=';

const OFFICIAL_BLE_TIMEOUT = 4500;
const BLESendInterval = 100;

const OfficialBLECommand = {
    CMD_DISPLAY_TEXT: 0x81,
    CMD_DISPLAY_LED: 0x82
};

const OfficialBLEUUID = {
    service: 0xf005,
    rxChar: '5261da01-fa7e-42ab-850b-7c80220097cc',
    txChar: '5261da02-fa7e-42ab-850b-7c80220097cc'
};

const MoreBLEUUID = {
    service: '0b50f3e4-607f-4151-9091-7d008d6ffc5c',
    command: '0b500100-607f-4151-9091-7d008d6ffc5c',
    state: '0b500101-607f-4151-9091-7d008d6ffc5c',
    motion: '0b500102-607f-4151-9091-7d008d6ffc5c',
    actionEvent: '0b500111-607f-4151-9091-7d008d6ffc5c',
    message: '0b500130-607f-4151-9091-7d008d6ffc5c'
};

const MoreCommand = {
    DISPLAY: 0x02,
    DATA: 0x04
};

const MoreDisplaySubcommand = {
    CLEAR: 0x00,
    TEXT: 0x01,
    PIXELS_1: 0x02
};

const MoreSendingDataType = {
    NUMBER: 0x01,
    TEXT: 0x02
};

const MoreMessageType = {
    NUMBER: 0x01,
    TEXT: 0x02
};

const MoreActionDataFormat = {
    ACTION_EVENT: 0x12
};

const MoreActionEventType = {
    BUTTON: 0x01,
    GESTURE: 0x02
};

const MoreButtonEventName = {
    DOWN: 0x01,
    UP: 0x02
};

const MoreButtonName = {
    A: 1,
    B: 2
};

const MoreGestureName = {
    FREEFALL: 7,
    SHAKE: 11
};

const MorePollInterval = 200;
const RADIO_SEPARATOR = String.fromCharCode(30);
const RADIO_GATEWAY_VENDOR_ID = 0x0d28;
const RADIO_GATEWAY_PRODUCT_ID = 0x0204;
const RADIO_GATEWAY_FLASH_SETTLE_MS = 2500;
const MICROBIT_CONNECTION_PROGRESS_EVENT = 'MICROBIT_CONNECTION_PROGRESS';
const USB_HANDSHAKE_TIMEOUT_MS = 2000;

const RadioLabel = {
    GROUP: 'group',
    PAYLOAD: 'radio'
};

const RadioGatewaySendCommand = {
    GATEWAY_QUESTION: 'RG?',
    SET_GROUP: 'RSG',
    SEND_NUMBER: 'RSN',
    SEND_STRING: 'RSS'
};

const RadioGatewayReceivedCommand = {
    GATEWAY_RESPONSE_YES: 'YES',
    HEARTBEAT: 'HB',
    RECEIVED_NUMBER: 'ORRN',
    RECEIVED_STRING: 'ORRS'
};

const USBMicrobitSendCommand = {
    HELLO: 'MB?',
    DISPLAY_TEXT: 'MDT',
    DISPLAY_NUMBER: 'MDN',
    DISPLAY_MATRIX: 'MDM',
    CLEAR_DISPLAY: 'MDC',
    REQUEST_SOUND_LEVEL: 'MSR',
    SET_GROUP: 'RSG',
    SEND_NUMBER: 'RSN',
    SEND_STRING: 'RSS'
};

const USBMicrobitReceivedCommand = {
    HELLO: 'MBO',
    STATE: 'MBS',
    RECEIVED_NUMBER: 'MBRN',
    RECEIVED_STRING: 'MBRT'
};

const trimNulls = value => value.replace(/\0/g, '').trim();
const withTimeout = (promise, timeoutMs, label) => new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
        reject(new Error(`${label} timed out after ${timeoutMs}ms`));
    }, timeoutMs);
    promise.then(value => {
        clearTimeout(timeoutId);
        resolve(value);
    }).catch(error => {
        clearTimeout(timeoutId);
        reject(error);
    });
});

const getStaticMicrobitHexURL = fileName => {
    if (typeof window === 'undefined' || !window.location) {
        return `/static/microbit/${fileName}`;
    }
    return new URL(`/static/microbit/${fileName}`, window.location.origin).toString();
};

const getOfficialMicrobitHexURL = () => getStaticMicrobitHexURL('scratch-microbit-1.2.0.hex');
const getRadioGatewayHexURL = () => getStaticMicrobitHexURL('microbit-RadioGateway.hex');
const getUsbUniversalHexURL = () => getStaticMicrobitHexURL('microbit-USBUniversal.hex');

const getNavigatorBluetooth = () => {
    if (typeof navigator === 'undefined') return null;
    return navigator.bluetooth || null;
};

const getNavigatorUsb = () => {
    if (typeof navigator === 'undefined') return null;
    return navigator.usb || null;
};

const getNavigatorSerial = () => {
    if (typeof navigator === 'undefined') return null;
    return navigator.serial || null;
};

const getDirectoryPicker = () => {
    if (typeof window !== 'undefined' && typeof window.showDirectoryPicker === 'function') {
        return window.showDirectoryPicker.bind(window);
    }
    if (typeof showDirectoryPicker === 'function') {
        return showDirectoryPicker;
    }
    return null;
};

const getLocalStorage = () => {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage || null;
    } catch (error) {
        return null;
    }
};

const getMicrobitBoardSerialPrefix = device => String(
    device && device.serialNumber ? device.serialNumber : ''
).slice(0, 4);

const getMicrobitUniversalBoardIdForDevice = device => {
    const prefix = getMicrobitBoardSerialPrefix(device);
    if (prefix === '9900' || prefix === '9901') {
        return microbitUniversalHex.microbitBoardId.V1;
    }
    if (/^990[3-9]$/.test(prefix)) {
        return microbitUniversalHex.microbitBoardId.V2;
    }
    return null;
};

const encodeTextBuffer = text => {
    const safe = String(text || '');
    const bytes = new Uint8Array(safe.length);
    for (let i = 0; i < safe.length; i++) {
        bytes[i] = safe.charCodeAt(i) & 0xFF;
    }
    return bytes.buffer;
};

const USB_MICROBIT_FIRMWARE_HINT_KEY = 'scratch.microbit.usbFirmwareInstalled.v2';

const encodeAscii = (text, maxLength) => {
    const bytes = new Uint8Array(maxLength);
    const safe = String(text || '').slice(0, maxLength);
    for (let i = 0; i < safe.length; i++) {
        bytes[i] = safe.charCodeAt(i) & 0x7F;
    }
    return bytes;
};

const decodeAscii = (bytes, startIndex, endIndex) => {
    let result = '';
    for (let i = startIndex; i < endIndex; i++) {
        if (!bytes[i]) break;
        result += String.fromCharCode(bytes[i]);
    }
    return trimNulls(result);
};

class MicroBit {
    constructor (runtime, extensionId) {
        this._runtime = runtime;
        this._extensionId = extensionId;
        this._runtime.registerPeripheralExtension(extensionId, this);

        this._device = null;
        this._server = null;
        this._connected = false;
        this._mode = null;
        this._officialChars = null;
        this._moreChars = null;
        this._officialTimeoutID = null;
        this._morePollIntervalID = null;
        this._gestureResetTimeoutID = null;

        this._sensors = {
            tiltX: 0,
            tiltY: 0,
            buttonA: 0,
            buttonB: 0,
            touchPins: [0, 0, 0],
            gestureState: 0,
            temperature: 0,
            lightLevel: 0,
            soundLevel: 0,
            accelerationX: 0,
            accelerationY: 0,
            accelerationZ: 0,
            ledMatrixState: new Uint8Array(5)
        };

        this._radio = {
            group: 0,
            lastLabel: '',
            lastNumber: 0,
            lastText: '',
            serial: 0
        };
        this._radioGateway = {
            device: null,
            target: null,
            connectPromise: null,
            ready: false,
            buffer: '',
            firmwareBuffer: null
        };
        this._usbMicrobit = {
            device: null,
            target: null,
            connectPromise: null,
            ready: false,
            buffer: '',
            firmwareBuffer: null,
            driveHandle: null,
            readLoopPromise: null,
            disconnecting: false,
            lastSoundRequestTime: 0
        };
        this._officialFirmwareBuffer = null;

        this._handleGattDisconnected = this._handleGattDisconnected.bind(this);
        this._handleOfficialNotification = this._handleOfficialNotification.bind(this);
        this._handleMoreActionNotification = this._handleMoreActionNotification.bind(this);
        this._handleMoreMessageNotification = this._handleMoreMessageNotification.bind(this);
        this._handleUsbDisconnect = this._handleUsbDisconnect.bind(this);
    }

    get tiltX () {
        return this._sensors.tiltX;
    }

    get tiltY () {
        return this._sensors.tiltY;
    }

    get buttonA () {
        return this._sensors.buttonA;
    }

    get buttonB () {
        return this._sensors.buttonB;
    }

    get gestureState () {
        return this._sensors.gestureState;
    }

    get temperature () {
        return this._sensors.temperature;
    }

    get lightLevel () {
        return this._sensors.lightLevel;
    }

    get soundLevel () {
        return this._sensors.soundLevel;
    }

    get accelerationX () {
        return this._sensors.accelerationX;
    }

    get accelerationY () {
        return this._sensors.accelerationY;
    }

    get accelerationZ () {
        return this._sensors.accelerationZ;
    }

    get ledMatrixState () {
        return this._sensors.ledMatrixState;
    }

    get lastRadioNumber () {
        return this._radio.lastNumber;
    }

    get lastRadioText () {
        return this._radio.lastText;
    }

    isRadioGatewayConnected () {
        return Boolean(
            this._radioGateway.ready &&
            this._radioGateway.device &&
            this._radioGateway.device.opened
        );
    }

    isUsbMicrobitConnected () {
        return Boolean(
            this._usbMicrobit.ready &&
            this._usbMicrobit.device &&
            this._usbMicrobit.device.opened
        );
    }

    connectRadioGateway () {
        return this._ensureRadioGatewayConnected();
    }

    async connectOfficialBluetooth () {
        this._showConnectionProgress('Forbinder Micro:bit', null, 'Forbereder firmware til Micro:bit...');
        try {
            await this._flashOfficialFirmware();
        } catch (error) {
            log.warn(`micro:bit official firmware flash skipped: ${error && error.message ? error.message : error}`);
        }
        this._showConnectionProgress('Forbinder Micro:bit', null, 'Ã…bner Bluetooth-parring...');
        return this.scan();
    }

    consumeRadioReceived (oldSerial) {
        return this._radio.serial !== 0 && this._radio.serial !== oldSerial;
    }

    async scan () {
        const bluetooth = getNavigatorBluetooth();
        if (!bluetooth) {
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Web Bluetooth is not available in this browser'
            });
            return;
        }

        try {
            const device = await bluetooth.requestDevice({
                filters: [
                    {services: [MoreBLEUUID.service]},
                    {services: [OfficialBLEUUID.service]}
                ],
                optionalServices: [
                    MoreBLEUUID.service,
                    OfficialBLEUUID.service
                ]
            });

            if (!device) {
                this._hideConnectionProgress();
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_SCAN_TIMEOUT);
                return;
            }

            this._device = device;
            this._device.removeEventListener('gattserverdisconnected', this._handleGattDisconnected);
            this._device.addEventListener('gattserverdisconnected', this._handleGattDisconnected);

            this._runtime.emit(this._runtime.constructor.USER_PICKED_PERIPHERAL, {
                [device.id]: {
                    peripheralId: device.id,
                    name: device.name || 'micro:bit'
                }
            });

            await this.connect(device.id);
        } catch (error) {
            this._hideConnectionProgress();
            if (error && error.name === 'NotFoundError') {
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Ingen micro:bit blev fundet via Bluetooth. Kablet alene virker ikke til denne forbindelse. VÃ¦lg "Radio gateway (USB)" hvis du vil bruge kabel.'
                });
            } else {
                log.error(`micro:bit scan error: ${error && error.message ? error.message : error}`);
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Could not request a micro:bit from Web Bluetooth'
                });
            }
        }
    }

    async connect (id) {
        if (!this._device || this._device.id !== id || !this._device.gatt) {
            return;
        }

        await this._disconnectSilently();

        try {
            this._server = await this._device.gatt.connect();
            if (await this._tryConnectMore()) {
                this._mode = 'more';
            } else if (await this._tryConnectOfficial()) {
                this._mode = 'official';
            } else {
                throw new Error('No supported micro:bit BLE service found');
            }

            this._connected = true;
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTED);
        } catch (error) {
            log.error(`micro:bit connect error: ${error && error.message ? error.message : error}`);
            await this._disconnectSilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Could not connect to the selected micro:bit'
            });
        }
    }

    disconnect () {
        this._disconnectSilently().finally(() => {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_DISCONNECTED);
        });
    }

    reset () {
        if (this._officialTimeoutID) {
            clearTimeout(this._officialTimeoutID);
            this._officialTimeoutID = null;
        }
        if (this._morePollIntervalID) {
            clearInterval(this._morePollIntervalID);
            this._morePollIntervalID = null;
        }
        if (this._gestureResetTimeoutID) {
            clearTimeout(this._gestureResetTimeoutID);
            this._gestureResetTimeoutID = null;
        }
        this._sensors.buttonA = 0;
        this._sensors.buttonB = 0;
        this._sensors.gestureState = 0;
    }

    isConnected () {
        return Boolean(
            this._connected &&
            this._device &&
            this._device.gatt &&
            this._device.gatt.connected
        );
    }

    displayText (text) {
        if (!this.isConnected()) return Promise.resolve();

        if (this._mode === 'more') {
            const bytes = encodeAscii(String(text).substring(0, 18), 18);
            const payload = new Uint8Array(20);
            payload[0] = (MoreCommand.DISPLAY << 5) | MoreDisplaySubcommand.TEXT;
            payload[1] = 120;
            payload.set(bytes, 2);
            return this._writeMoreCommand(payload);
        }

        const output = encodeAscii(text, String(text).length);
        return this._writeOfficialCommand(OfficialBLECommand.CMD_DISPLAY_TEXT, output);
    }

    displayMatrix (matrix) {
        if (!this.isConnected()) return Promise.resolve();

        if (this._mode === 'more') {
            const payload = new Uint8Array(20);
            payload[0] = (MoreCommand.DISPLAY << 5) | MoreDisplaySubcommand.PIXELS_1;
            payload[1] = 0;
            payload.set(matrix.slice(0, 5), 2);
            return this._writeMoreCommand(payload);
        }

        return this._writeOfficialCommand(OfficialBLECommand.CMD_DISPLAY_LED, matrix);
    }

    setRadioGroup (group) {
        const safeGroup = Math.max(0, Math.min(255, cast.toNumber(group)));
        this._radio.group = safeGroup;
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SET_GROUP, safeGroup);
    }

    sendRadioNumber (value) {
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SEND_NUMBER, cast.toNumber(value));
    }

    sendRadioText (text) {
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SEND_STRING, String(text));
    }

    _setGestureBits (bits) {
        this._sensors.gestureState = bits;
        if (this._gestureResetTimeoutID) {
            clearTimeout(this._gestureResetTimeoutID);
        }
        this._gestureResetTimeoutID = setTimeout(() => {
            this._sensors.gestureState = 0;
        }, 300);
    }

    _updateRadioMessage (label, type, value) {
        this._radio.lastLabel = label;
        this._radio.serial += 1;
        if (type === MoreMessageType.NUMBER) {
            this._radio.lastNumber = value;
            this._radio.lastText = String(value);
        } else {
            this._radio.lastText = value;
            const numericValue = Number(value);
            this._radio.lastNumber = Number.isNaN(numericValue) ? 0 : numericValue;
        }
    }

    async _ensureRadioGatewayConnected () {
        if (this._radioGateway.ready && this._radioGateway.device && this._radioGateway.device.opened) {
            return;
        }
        if (this._radioGateway.connectPromise) {
            return this._radioGateway.connectPromise;
        }

        const usb = getNavigatorUsb();
        if (!usb) {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'WebUSB er ikke tilgÃ¦ngelig i denne browser'
            });
            return;
        }

        this._radioGateway.connectPromise = this._connectRadioGateway(usb)
            .finally(() => {
                this._radioGateway.connectPromise = null;
            });
        return this._radioGateway.connectPromise;
    }

    async _connectRadioGateway (usb) {
        try {
            this._showConnectionProgress('Forbinder radio-gateway', null, 'VÃ¦lg din Micro:bit til radio-gateway...');
            usb.removeEventListener('disconnect', this._handleUsbDisconnect);
            usb.addEventListener('disconnect', this._handleUsbDisconnect);

            const device = await usb.requestDevice({
                filters: [{
                    vendorId: RADIO_GATEWAY_VENDOR_ID
                }]
            });

            if (!device) return;

            const transport = new DAPjs.WebUSB(device);
            const target = new DAPjs.DAPLink(transport);
            await target.connect();
            await this._flashRadioGatewayFirmware(target);
            this._showConnectionProgress('Forbinder radio-gateway', null, 'GÃ¸r radio-gateway klar...');
            await target.setSerialBaudrate(115200);

            this._radioGateway.device = device;
            this._radioGateway.target = target;
            this._radioGateway.ready = false;
            this._radioGateway.buffer = '';

            target.on(DAPjs.DAPLink.EVENT_SERIAL_DATA, data => {
                this._handleRadioGatewaySerialData(data);
            });

            await target.startSerialRead(1);
            await target.serialWrite(`${RadioGatewaySendCommand.GATEWAY_QUESTION}\n`);
            this._radioGateway.ready = true;
            this._hideConnectionProgress();
        } catch (error) {
            log.error(`micro:bit radio gateway connect error: ${error && error.message ? error.message : error}`);
            await this._disconnectRadioGatewaySilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Kunne ikke forbinde til micro:bit radio-gatewayen over USB'
            });
        }
    }

    async _flashOfficialFirmware () {
        const usb = getNavigatorUsb();
        if (!usb) {
            return;
        }

        let device = null;
        let target = null;
        try {
            this._showConnectionProgress('Forbinder Micro:bit', null, 'Vælg din Micro:bit for at overføre firmware...');
            device = await usb.requestDevice({
                filters: [{
                    vendorId: RADIO_GATEWAY_VENDOR_ID
                }]
            });

            if (!device) {
                return;
            }

            const firmwareBuffer = await this._getOfficialDirectFlashBuffer(device);
            if (!firmwareBuffer) {
                return;
            }

            target = new DAPjs.DAPLink(new DAPjs.WebUSB(device));
            await target.connect();
            target.on(DAPjs.DAPLink.EVENT_PROGRESS, progress => {
                this._showConnectionProgress(
                    'Forbinder Micro:bit',
                    progress,
                    'Overfører firmware til Micro:bit...'
                );
            });
            await target.flash(firmwareBuffer);
            await new Promise(resolve => setTimeout(resolve, RADIO_GATEWAY_FLASH_SETTLE_MS));
        } catch (error) {
            if (error && error.name === 'NotFoundError') {
                return;
            }
            log.error(`micro:bit official firmware flash error: ${error && error.message ? error.message : error}`);
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Kunne ikke installere Scratch-firmwaren på micro:bit over USB'
            });
        } finally {
            if (target) {
                try {
                    await target.disconnect();
                } catch (error) {
                    log.warn(`micro:bit official firmware target disconnect failed: ${error && error.message ? error.message : error}`);
                }
            }
            if (device && device.opened) {
                try {
                    await device.close();
                } catch (error) {
                    log.warn(`micro:bit official firmware device close failed: ${error && error.message ? error.message : error}`);
                }
            }
        }
    }

    async _flashRadioGatewayFirmware (target) {
        const firmwareBuffer = await this._getRadioGatewayFirmwareBuffer();
        if (!firmwareBuffer) {
            throw new Error('Radio gateway firmware is missing');
        }

        target.on(DAPjs.DAPLink.EVENT_PROGRESS, progress => {
            this._showConnectionProgress(
                'Forbinder radio-gateway',
                progress,
                'OverfÃ¸rer gateway-firmware til Micro:bit...'
            );
        });
        await target.flash(firmwareBuffer);
        await new Promise(resolve => setTimeout(resolve, RADIO_GATEWAY_FLASH_SETTLE_MS));
    }

    async _getRadioGatewayFirmwareBuffer () {
        if (this._radioGateway.firmwareBuffer) {
            return this._radioGateway.firmwareBuffer;
        }

        if (typeof fetch !== 'function') {
            return null;
        }

        const response = await fetch(getRadioGatewayHexURL());
        if (!response.ok) {
            throw new Error(`Could not load radio gateway firmware (${response.status})`);
        }

        this._radioGateway.firmwareBuffer = await response.arrayBuffer();
        return this._radioGateway.firmwareBuffer;
    }

    async _getOfficialFirmwareBuffer () {
        if (this._officialFirmwareBuffer) {
            return this._officialFirmwareBuffer;
        }

        if (typeof fetch !== 'function') {
            return null;
        }

        const response = await fetch(getOfficialMicrobitHexURL());
        if (!response.ok) {
            throw new Error(`Could not load official micro:bit firmware (${response.status})`);
        }

        this._officialFirmwareBuffer = await response.arrayBuffer();
        return this._officialFirmwareBuffer;
    }

    _showConnectionProgress (title, progress, detail) {
        this._runtime.emit(MICROBIT_CONNECTION_PROGRESS_EVENT, {
            extensionId: this._extensionId,
            visible: true,
            title,
            detail,
            progress: typeof progress === 'number' ? progress : null
        });
    }

    _hideConnectionProgress () {
        this._runtime.emit(MICROBIT_CONNECTION_PROGRESS_EVENT, {
            extensionId: this._extensionId,
            visible: false
        });
    }

    _handleRadioGatewaySerialData (data) {
        this._radioGateway.buffer += String(data || '');
        this._radioGateway.buffer = this._radioGateway.buffer.replace(/ *\r\n/g, '\n');

        let newlineIndex = this._radioGateway.buffer.indexOf('\n');
        while (newlineIndex >= 0) {
            const line = this._radioGateway.buffer.slice(0, newlineIndex);
            this._radioGateway.buffer = this._radioGateway.buffer.slice(newlineIndex + 1);
            this._handleRadioGatewayLine(line);
            newlineIndex = this._radioGateway.buffer.indexOf('\n');
        }
    }

    _handleRadioGatewayLine (line) {
        if (!line) return;

        const parts = line.split(RADIO_SEPARATOR).map(part => part.trim());
        switch (parts[0]) {
        case RadioGatewayReceivedCommand.GATEWAY_RESPONSE_YES:
        case RadioGatewayReceivedCommand.HEARTBEAT:
            return;
        case RadioGatewayReceivedCommand.RECEIVED_NUMBER:
            this._updateRadioMessage(
                RadioLabel.PAYLOAD,
                MoreMessageType.NUMBER,
                cast.toNumber(parts[1])
            );
            return;
        case RadioGatewayReceivedCommand.RECEIVED_STRING:
            this._updateRadioMessage(
                RadioLabel.PAYLOAD,
                MoreMessageType.TEXT,
                cast.toString(parts[1])
            );
            return;
        default:
            return;
        }
    }

    async _sendRadioGatewayCommand (...parts) {
        await this._ensureRadioGatewayConnected();
        if (!this._radioGateway.target) return;

        const message = parts.map(part => cast.toString(part)).join(RADIO_SEPARATOR);
        return this._radioGateway.target.serialWrite(`${message}\n`);
    }

    _handleUsbDisconnect (event) {
        if (!event || !event.device || event.device !== this._radioGateway.device) {
            return;
        }

        this._disconnectRadioGatewaySilently().catch(error => {
            log.warn(`micro:bit radio gateway disconnect cleanup failed: ${error && error.message ? error.message : error}`);
        });
    }

    async _disconnectRadioGatewaySilently () {
        const {device, target} = this._radioGateway;
        this._radioGateway.ready = false;
        this._radioGateway.buffer = '';

        if (target) {
            try {
                await target.stopSerialRead();
            } catch (error) {
                log.warn(`micro:bit radio gateway stopSerialRead failed: ${error && error.message ? error.message : error}`);
            }
            try {
                await target.disconnect();
            } catch (error) {
                log.warn(`micro:bit radio gateway target disconnect failed: ${error && error.message ? error.message : error}`);
            }
        }

        if (device && device.opened) {
            try {
                await device.close();
            } catch (error) {
                log.warn(`micro:bit radio gateway device close failed: ${error && error.message ? error.message : error}`);
            }
        }

        this._radioGateway.device = null;
        this._radioGateway.target = null;
    }

    async _tryConnectOfficial () {
        try {
            const service = await this._server.getPrimaryService(OfficialBLEUUID.service);
            const rxChar = await service.getCharacteristic(OfficialBLEUUID.rxChar);
            const txChar = await service.getCharacteristic(OfficialBLEUUID.txChar);
            await rxChar.startNotifications();
            rxChar.addEventListener('characteristicvaluechanged', this._handleOfficialNotification);
            this._officialChars = {rxChar, txChar};
            this._resetOfficialTimeout();
            return true;
        } catch (error) {
            return false;
        }
    }

    async _tryConnectMore () {
        try {
            const service = await this._server.getPrimaryService(MoreBLEUUID.service);
            const commandChar = await service.getCharacteristic(MoreBLEUUID.command);
            const stateChar = await service.getCharacteristic(MoreBLEUUID.state);
            const motionChar = await service.getCharacteristic(MoreBLEUUID.motion);
            const actionEventChar = await service.getCharacteristic(MoreBLEUUID.actionEvent);

            let messageChar = null;
            try {
                messageChar = await service.getCharacteristic(MoreBLEUUID.message);
            } catch (e) {
                messageChar = null;
            }

            await actionEventChar.startNotifications();
            actionEventChar.addEventListener('characteristicvaluechanged', this._handleMoreActionNotification);

            if (messageChar) {
                await messageChar.startNotifications();
                messageChar.addEventListener('characteristicvaluechanged', this._handleMoreMessageNotification);
            }

            this._moreChars = {
                commandChar,
                stateChar,
                motionChar,
                actionEventChar,
                messageChar
            };

            await this._pollMoreSensors();
            this._morePollIntervalID = setInterval(() => {
                this._pollMoreSensors().catch(error => {
                    log.warn(`micro:bit sensor poll failed: ${error && error.message ? error.message : error}`);
                });
            }, MorePollInterval);
            return true;
        } catch (error) {
            return false;
        }
    }

    async _pollMoreSensors () {
        if (!this._moreChars) return;

        const stateValue = await this._moreChars.stateChar.readValue();
        this._parseMoreState(new Uint8Array(stateValue.buffer.slice(0)));

        const motionValue = await this._moreChars.motionChar.readValue();
        this._parseMoreMotion(new Uint8Array(motionValue.buffer.slice(0)));
    }

    async _writeOfficialCommand (command, message) {
        const output = new Uint8Array(message.length + 1);
        output[0] = command;
        output.set(message, 1);
        return this._officialChars.txChar.writeValue(output);
    }

    async _writeMoreCommand (payload) {
        if (!this._moreChars) return;
        return this._moreChars.commandChar.writeValue(payload);
    }

    async _sendMoreData (label, type, value) {
        if (!this.isConnected() || this._mode !== 'more') {
            return;
        }

        const payload = new Uint8Array(20);
        payload[0] = (MoreCommand.DATA << 5) | type;
        payload.set(encodeAscii(label, 8), 1);

        if (type === MoreSendingDataType.NUMBER) {
            new DataView(payload.buffer).setFloat32(9, cast.toNumber(value), true);
        } else {
            payload.set(encodeAscii(String(value), 11), 9);
        }

        return this._writeMoreCommand(payload);
    }

    _handleOfficialNotification (event) {
        const data = new Uint8Array(event.target.value.buffer.slice(0));

        this._sensors.tiltX = data[1] | (data[0] << 8);
        if (this._sensors.tiltX > (1 << 15)) this._sensors.tiltX -= (1 << 16);

        this._sensors.tiltY = data[3] | (data[2] << 8);
        if (this._sensors.tiltY > (1 << 15)) this._sensors.tiltY -= (1 << 16);

        this._sensors.buttonA = data[4];
        this._sensors.buttonB = data[5];
        this._sensors.touchPins[0] = data[6];
        this._sensors.touchPins[1] = data[7];
        this._sensors.touchPins[2] = data[8];
        this._sensors.gestureState = data[9];

        this._resetOfficialTimeout();
    }

    _parseMoreState (data) {
        this._sensors.touchPins[0] = data[0] & 0x01 ? 1 : 0;
        this._sensors.touchPins[1] = data[0] & 0x02 ? 1 : 0;
        this._sensors.touchPins[2] = data[0] & 0x04 ? 1 : 0;
    }

    _parseMoreMotion (data) {
        const view = new DataView(data.buffer);
        const pitch = view.getInt16(0, true);
        const roll = view.getInt16(2, true);

        this._sensors.tiltY = pitch * -10;
        this._sensors.tiltX = roll * 10;
    }

    _handleMoreActionNotification (event) {
        const data = new Uint8Array(event.target.value.buffer.slice(0));
        if (data[19] !== MoreActionDataFormat.ACTION_EVENT) {
            return;
        }

        const view = new DataView(data.buffer);
        if (data[0] === MoreActionEventType.BUTTON) {
            const buttonName = view.getUint16(1, true);
            const buttonEvent = data[3];
            const nextValue = buttonEvent === MoreButtonEventName.UP ? 0 : 1;
            if (buttonName === MoreButtonName.A) {
                this._sensors.buttonA = nextValue;
            }
            if (buttonName === MoreButtonName.B) {
                this._sensors.buttonB = nextValue;
            }
            return;
        }

        if (data[0] === MoreActionEventType.GESTURE) {
            let bits = 0b100;
            if (data[1] === MoreGestureName.SHAKE) {
                bits |= 0b001;
            }
            if (data[1] === MoreGestureName.FREEFALL) {
                bits |= 0b010;
            }
            this._setGestureBits(bits);
        }
    }

    _handleMoreMessageNotification (event) {
        const data = new Uint8Array(event.target.value.buffer.slice(0));
        const label = decodeAscii(data, 0, 8);
        const type = data[19];

        if (type === MoreMessageType.NUMBER) {
            const value = new DataView(data.buffer).getFloat32(8, true);
            this._updateRadioMessage(label, type, value);
            return;
        }

        if (type === MoreMessageType.TEXT) {
            const value = decodeAscii(data, 8, 19);
            this._updateRadioMessage(label, type, value);
        }
    }

    _resetOfficialTimeout () {
        if (this._officialTimeoutID) {
            clearTimeout(this._officialTimeoutID);
        }
        this._officialTimeoutID = setTimeout(() => {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTION_LOST_ERROR, {
                extensionId: this._extensionId,
                message: 'micro:bit stopped sending BLE data'
            });
            this.disconnect();
        }, OFFICIAL_BLE_TIMEOUT);
    }

    _handleGattDisconnected () {
        if (!this._connected) return;
        this._disconnectSilently().finally(() => {
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTION_LOST_ERROR, {
                extensionId: this._extensionId,
                message: 'micro:bit disconnected'
            });
        });
    }

    async _disconnectSilently () {
        this.reset();
        await this._disconnectRadioGatewaySilently();
        this._hideConnectionProgress();

        if (this._officialChars && this._officialChars.rxChar) {
            this._officialChars.rxChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleOfficialNotification
            );
        }
        if (this._moreChars && this._moreChars.actionEventChar) {
            this._moreChars.actionEventChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleMoreActionNotification
            );
        }
        if (this._moreChars && this._moreChars.messageChar) {
            this._moreChars.messageChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleMoreMessageNotification
            );
        }

        if (this._device && this._device.gatt && this._device.gatt.connected) {
            this._device.gatt.disconnect();
        }

        this._server = null;
        this._officialChars = null;
        this._moreChars = null;
        this._mode = null;
        this._connected = false;
    }

    async connectOfficialBluetooth () {
        return this._ensureUsbMicrobitConnected();
    }

    isConnected () {
        if (this._mode === 'usb') {
            return this.isUsbMicrobitConnected();
        }
        return Boolean(
            this._connected &&
            this._device &&
            this._device.gatt &&
            this._device.gatt.connected
        );
    }

    displayText (text) {
        if (!this.isConnected()) return Promise.resolve();

        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(USBMicrobitSendCommand.DISPLAY_TEXT, String(text));
        }

        if (this._mode === 'more') {
            const bytes = encodeAscii(String(text).substring(0, 18), 18);
            const payload = new Uint8Array(20);
            payload[0] = (MoreCommand.DISPLAY << 5) | MoreDisplaySubcommand.TEXT;
            payload[1] = 120;
            payload.set(bytes, 2);
            return this._writeMoreCommand(payload);
        }

        const output = encodeAscii(text, String(text).length);
        return this._writeOfficialCommand(OfficialBLECommand.CMD_DISPLAY_TEXT, output);
    }

    displayNumber (value) {
        if (!this.isConnected()) return Promise.resolve();

        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(USBMicrobitSendCommand.DISPLAY_NUMBER, cast.toNumber(value));
        }

        return this.displayText(cast.toNumber(value));
    }

    displayMatrix (matrix) {
        if (!this.isConnected()) return Promise.resolve();

        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(
                USBMicrobitSendCommand.DISPLAY_MATRIX,
                Array.from(matrix.slice(0, 5)).join(',')
            );
        }

        if (this._mode === 'more') {
            const payload = new Uint8Array(20);
            payload[0] = (MoreCommand.DISPLAY << 5) | MoreDisplaySubcommand.PIXELS_1;
            payload[1] = 0;
            payload.set(matrix.slice(0, 5), 2);
            return this._writeMoreCommand(payload);
        }

        return this._writeOfficialCommand(OfficialBLECommand.CMD_DISPLAY_LED, matrix);
    }

    setRadioGroup (group) {
        const safeGroup = Math.max(0, Math.min(255, cast.toNumber(group)));
        this._radio.group = safeGroup;
        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(USBMicrobitSendCommand.SET_GROUP, safeGroup);
        }
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SET_GROUP, safeGroup);
    }

    sendRadioNumber (value) {
        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(USBMicrobitSendCommand.SEND_NUMBER, cast.toNumber(value));
        }
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SEND_NUMBER, cast.toNumber(value));
    }

    sendRadioText (text) {
        if (this._mode === 'usb') {
            return this._sendUsbMicrobitCommand(USBMicrobitSendCommand.SEND_STRING, String(text));
        }
        return this._sendRadioGatewayCommand(RadioGatewaySendCommand.SEND_STRING, String(text));
    }

    async _getAuthorizedOrRequestUsbDevice (usb, requestDetail) {
        const authorizedDevices = typeof usb.getDevices === 'function' ?
            (await usb.getDevices()).filter(device => device.vendorId === RADIO_GATEWAY_VENDOR_ID) :
            [];
        if (authorizedDevices.length) {
            return authorizedDevices[0];
        }

        this._showConnectionProgress('Forbinder Micro:bit', null, requestDetail);
        return usb.requestDevice({
            filters: [{
                vendorId: RADIO_GATEWAY_VENDOR_ID
            }]
        });
    }

    async _ensureUsbMicrobitConnected () {
        if (this.isUsbMicrobitConnected()) {
            return;
        }
        if (this._usbMicrobit.connectPromise) {
            return this._usbMicrobit.connectPromise;
        }

        const usb = getNavigatorUsb();
        if (!usb) {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'WebUSB er ikke tilgÃ¦ngelig i denne browser'
            });
            return;
        }

        this._usbMicrobit.connectPromise = this._connectUsbMicrobit(usb)
            .finally(() => {
                this._usbMicrobit.connectPromise = null;
            });
        return this._usbMicrobit.connectPromise;
    }

    async _connectUsbMicrobit (usb) {
        try {
            this._showConnectionProgress('Forbinder Micro:bit', null, 'Vælg din Micro:bit for at forbinde med kabel...');
            usb.removeEventListener('disconnect', this._handleUsbDisconnect);
            usb.addEventListener('disconnect', this._handleUsbDisconnect);

            const device = await usb.requestDevice({
                filters: [{
                    vendorId: RADIO_GATEWAY_VENDOR_ID
                }]
            });

            if (!device) return;

            let target = new DAPjs.DAPLink(new DAPjs.WebUSB(device));
            await target.connect();

            this._usbMicrobit.device = device;
            this._usbMicrobit.target = target;
            this._usbMicrobit.ready = false;
            this._usbMicrobit.buffer = '';

            await this._flashUsbMicrobitFirmware(target);

            if (!connected) {
                this._showConnectionProgress('Forbinder Micro:bit', null, 'Overfører firmware til Micro:bit...');
                await this._flashUsbMicrobitFirmware(target);
                await target.disconnect();
                await new Promise(resolve => setTimeout(resolve, 1500));
                await target.connect();
                await target.setSerialBaudrate(115200);
                connected = await this._tryUsbMicrobitHandshake(target, 6, 700);
            }

            if (!connected || !this._usbMicrobit.ready) {
                throw new Error('USB micro:bit firmware did not answer handshake');
            }

            this._mode = 'usb';
            this._connected = true;
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTED);
        } catch (error) {
            log.error(`micro:bit usb connect error: ${error && error.message ? error.message : error}`);
            await this._disconnectUsbMicrobitSilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Kunne ikke forbinde til Micro:bit over USB'
            });
        }
    }

    async _connectUsbMicrobit (usb) {
        try {
            this._showConnectionProgress('Forbinder Micro:bit', null, 'Vælg din Micro:bit for at forbinde med kabel...');
            usb.removeEventListener('disconnect', this._handleUsbDisconnect);
            usb.addEventListener('disconnect', this._handleUsbDisconnect);

            const device = await usb.requestDevice({
                filters: [{
                    vendorId: RADIO_GATEWAY_VENDOR_ID
                }]
            });

            if (!device) return;

            let target = new DAPjs.DAPLink(new DAPjs.WebUSB(device));
            await target.connect();

            this._usbMicrobit.device = device;
            this._usbMicrobit.target = target;
            this._usbMicrobit.ready = false;
            this._usbMicrobit.buffer = '';

            this._showConnectionProgress('Forbinder Micro:bit', null, 'Overfører firmware til Micro:bit...');
            await this._flashUsbMicrobitFirmware(target);

            try {
                await target.disconnect();
            } catch (disconnectError) {
                log.warn(`micro:bit usb disconnect after flash failed: ${disconnectError && disconnectError.message ? disconnectError.message : disconnectError}`);
            }

            if (device && device.opened) {
                try {
                    await device.close();
                } catch (closeError) {
                    log.warn(`micro:bit usb device close after flash failed: ${closeError && closeError.message ? closeError.message : closeError}`);
                }
            }

            this._showConnectionProgress('Forbinder Micro:bit', null, 'Venter på at Micro:bit genstarter...');
            const reconnectedDevice = await this._waitForUsbMicrobitDevice(usb, device);

            target = new DAPjs.DAPLink(new DAPjs.WebUSB(reconnectedDevice || device));
            await target.connect();

            this._usbMicrobit.device = reconnectedDevice || device;
            this._usbMicrobit.target = target;
            this._usbMicrobit.ready = false;
            this._usbMicrobit.buffer = '';

            target.on(DAPjs.DAPLink.EVENT_SERIAL_DATA, data => {
                this._handleUsbMicrobitSerialData(data);
            });

            this._showConnectionProgress('Forbinder Micro:bit', null, 'Starter Micro:bit via kabel...');
            await target.setSerialBaudrate(115200);

            const connected = await this._tryUsbMicrobitHandshake(target, 10, 800);

            if (!connected || !this._usbMicrobit.ready) {
                throw new Error('USB micro:bit firmware did not answer handshake');
            }

            this._mode = 'usb';
            this._connected = true;
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTED);
        } catch (error) {
            const message = error && error.message ? error.message : error;
            log.error(`micro:bit usb connect error: ${message}`);
            await this._disconnectUsbMicrobitSilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: `Kunne ikke forbinde til Micro:bit over USB: ${message}`
            });
        }
    }

    async _waitForUsbMicrobitDevice (usb, originalDevice) {
        const originalSerial = originalDevice && originalDevice.serialNumber ? originalDevice.serialNumber : null;
        const deadline = Date.now() + 10000;

        while (Date.now() < deadline) {
            if (typeof usb.getDevices === 'function') {
                const devices = await usb.getDevices();
                const matchingDevice = devices.find(candidate => {
                    if (!candidate) return false;
                    if (originalSerial && candidate.serialNumber === originalSerial) return true;
                    return candidate.vendorId === RADIO_GATEWAY_VENDOR_ID;
                });
                if (matchingDevice) {
                    return matchingDevice;
                }
            }
            await new Promise(resolve => setTimeout(resolve, 400));
        }

        return originalDevice;
    }

    async _tryUsbMicrobitHandshake (target, attempts, delayMs) {
        this._usbMicrobit.ready = false;
        this._usbMicrobit.buffer = '';

        try {
            await withTimeout(target.startSerialRead(1), USB_HANDSHAKE_TIMEOUT_MS, 'startSerialRead');
        } catch (error) {
            log.warn(`micro:bit usb startSerialRead failed: ${error && error.message ? error.message : error}`);
            return false;
        }

        for (let attempt = 0; attempt < attempts && !this._usbMicrobit.ready; attempt++) {
            try {
                await withTimeout(
                    target.serialWrite(`${USBMicrobitSendCommand.HELLO}\n`),
                    USB_HANDSHAKE_TIMEOUT_MS,
                    'serialWrite'
                );
            } catch (error) {
                log.warn(`micro:bit usb handshake write failed: ${error && error.message ? error.message : error}`);
            }
            await new Promise(resolve => setTimeout(resolve, delayMs));
        }

        return this._usbMicrobit.ready;
    }

    async _flashUsbMicrobitFirmware (target, device = null) {
        const firmwareBuffer = await this._getUsbMicrobitDirectFlashBuffer(device);
        if (!firmwareBuffer) {
            throw new Error('USB micro:bit firmware is missing');
        }

        target.on(DAPjs.DAPLink.EVENT_PROGRESS, progress => {
            this._showConnectionProgress(
                'Forbinder Micro:bit',
                progress,
                'Overfører firmware til Micro:bit...'
            );
        });
        await target.flash(firmwareBuffer);
        await new Promise(resolve => setTimeout(resolve, RADIO_GATEWAY_FLASH_SETTLE_MS));
    }

    async _getUsbMicrobitFirmwareBuffer () {
        if (this._usbMicrobit.firmwareBuffer) {
            return this._usbMicrobit.firmwareBuffer;
        }

        if (typeof fetch !== 'function') {
            return null;
        }

        const response = await fetch(getUsbUniversalHexURL());
        if (!response.ok) {
            throw new Error(`Could not load USB micro:bit firmware (${response.status})`);
        }

        this._usbMicrobit.firmwareBuffer = await response.arrayBuffer();
        return this._usbMicrobit.firmwareBuffer;
    }

    async _getUsbMicrobitDirectFlashBuffer (device) {
        if (typeof fetch !== 'function') {
            return null;
        }

        const response = await fetch(getUsbUniversalHexURL());
        if (!response.ok) {
            throw new Error(`Could not load USB micro:bit firmware (${response.status})`);
        }

        const universalHexText = await response.text();
        const boardId = getMicrobitUniversalBoardIdForDevice(device);
        if (!boardId || !microbitUniversalHex.isUniversalHex(universalHexText)) {
            return encodeTextBuffer(universalHexText);
        }

        const splitHexes = microbitUniversalHex.separateUniversalHex(universalHexText);
        const selectedHex = splitHexes.find(entry => entry.boardId === boardId);
        if (!selectedHex) {
            return encodeTextBuffer(universalHexText);
        }

        return encodeTextBuffer(selectedHex.hex);
    }

    async _getOfficialDirectFlashBuffer (device) {
        if (typeof fetch !== 'function') {
            return null;
        }

        const response = await fetch(getOfficialMicrobitHexURL());
        if (!response.ok) {
            throw new Error(`Could not load official micro:bit firmware (${response.status})`);
        }

        const universalHexText = await response.text();
        const boardId = getMicrobitUniversalBoardIdForDevice(device);
        if (!boardId || !microbitUniversalHex.isUniversalHex(universalHexText)) {
            return encodeTextBuffer(universalHexText);
        }

        const splitHexes = microbitUniversalHex.separateUniversalHex(universalHexText);
        const selectedHex = splitHexes.find(entry => entry.boardId === boardId);
        if (!selectedHex) {
            return encodeTextBuffer(universalHexText);
        }

        return encodeTextBuffer(selectedHex.hex);
    }

    _handleUsbMicrobitSerialData (data) {
        this._usbMicrobit.buffer += String(data || '');
        this._usbMicrobit.buffer = this._usbMicrobit.buffer.replace(/ *\r\n/g, '\n');

        let newlineIndex = this._usbMicrobit.buffer.indexOf('\n');
        while (newlineIndex >= 0) {
            const line = this._usbMicrobit.buffer.slice(0, newlineIndex);
            this._usbMicrobit.buffer = this._usbMicrobit.buffer.slice(newlineIndex + 1);
            this._handleUsbMicrobitLine(line);
            newlineIndex = this._usbMicrobit.buffer.indexOf('\n');
        }
    }

    _handleUsbMicrobitLine (line) {
        if (!line) return;

        const parts = line.split(RADIO_SEPARATOR).map(part => part.trim());
        switch (parts[0]) {
        case USBMicrobitReceivedCommand.HELLO:
            this._usbMicrobit.ready = true;
            return;
        case USBMicrobitReceivedCommand.STATE:
            this._usbMicrobit.ready = true;
            this._updateUsbMicrobitState(parts);
            return;
        case USBMicrobitReceivedCommand.RECEIVED_NUMBER:
            this._updateRadioMessage(RadioLabel.PAYLOAD, MoreMessageType.NUMBER, cast.toNumber(parts[1]));
            return;
        case USBMicrobitReceivedCommand.RECEIVED_STRING:
            this._updateRadioMessage(RadioLabel.PAYLOAD, MoreMessageType.TEXT, cast.toString(parts.slice(1).join(RADIO_SEPARATOR)));
            return;
        default:
            return;
        }
    }

    _updateUsbMicrobitState (parts) {
        this._sensors.buttonA = cast.toNumber(parts[1]) ? 1 : 0;
        this._sensors.buttonB = cast.toNumber(parts[2]) ? 1 : 0;
        this._sensors.touchPins[0] = cast.toNumber(parts[3]) ? 1 : 0;
        this._sensors.touchPins[1] = cast.toNumber(parts[4]) ? 1 : 0;
        this._sensors.touchPins[2] = cast.toNumber(parts[5]) ? 1 : 0;
        this._sensors.tiltX = cast.toNumber(parts[6]);
        this._sensors.tiltY = cast.toNumber(parts[7]);
        this._sensors.gestureState = cast.toNumber(parts[8]) || 0;
        this._sensors.temperature = cast.toNumber(parts[9]) || 0;
        this._sensors.lightLevel = cast.toNumber(parts[10]) || 0;
        this._sensors.soundLevel = cast.toNumber(parts[11]) || 0;
        this._sensors.accelerationX = cast.toNumber(parts[12]) || 0;
        this._sensors.accelerationY = cast.toNumber(parts[13]) || 0;
        this._sensors.accelerationZ = cast.toNumber(parts[14]) || 0;
    }

    async _sendUsbMicrobitCommand (...parts) {
        await this._ensureUsbMicrobitConnected();
        if (!this._usbMicrobit.target) return;

        const message = parts.map(part => cast.toString(part)).join(RADIO_SEPARATOR);
        return this._usbMicrobit.target.serialWrite(`${message}\n`);
    }

    requestUsbMicrobitSoundLevel () {
        if (this._mode !== 'usb' || !this._usbMicrobit.target) {
            return;
        }
        const now = Date.now();
        if (now - this._usbMicrobit.lastSoundRequestTime < 200) {
            return;
        }
        this._usbMicrobit.lastSoundRequestTime = now;
        this._sendUsbMicrobitCommand(USBMicrobitSendCommand.REQUEST_SOUND_LEVEL)
            .catch(error => {
                log.warn(`micro:bit sound level request failed: ${error && error.message ? error.message : error}`);
            });
    }

    _handleUsbDisconnect (event) {
        if (!event || !event.device) return;

        if (event.device === this._usbMicrobit.device) {
            this._disconnectUsbMicrobitSilently().finally(() => {
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTION_LOST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Micro:bit USB-forbindelsen blev afbrudt'
                });
            });
            return;
        }

        if (event.device === this._radioGateway.device) {
            this._disconnectRadioGatewaySilently().catch(error => {
                log.warn(`micro:bit radio gateway disconnect cleanup failed: ${error && error.message ? error.message : error}`);
            });
        }
    }

    async _disconnectUsbMicrobitSilently () {
        const {device, target} = this._usbMicrobit;
        this._usbMicrobit.ready = false;
        this._usbMicrobit.buffer = '';

        if (target) {
            try {
                await target.stopSerialRead();
            } catch (error) {
                log.warn(`micro:bit usb stopSerialRead failed: ${error && error.message ? error.message : error}`);
            }
            try {
                await target.disconnect();
            } catch (error) {
                log.warn(`micro:bit usb target disconnect failed: ${error && error.message ? error.message : error}`);
            }
        }

        if (device && device.opened) {
            try {
                await device.close();
            } catch (error) {
                log.warn(`micro:bit usb device close failed: ${error && error.message ? error.message : error}`);
            }
        }

        this._usbMicrobit.device = null;
        this._usbMicrobit.target = null;
    }

    async _disconnectSilently () {
        this.reset();
        await this._disconnectRadioGatewaySilently();
        await this._disconnectUsbMicrobitSilently();
        this._hideConnectionProgress();

        if (this._officialChars && this._officialChars.rxChar) {
            this._officialChars.rxChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleOfficialNotification
            );
        }
        if (this._moreChars && this._moreChars.actionEventChar) {
            this._moreChars.actionEventChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleMoreActionNotification
            );
        }
        if (this._moreChars && this._moreChars.messageChar) {
            this._moreChars.messageChar.removeEventListener(
                'characteristicvaluechanged',
                this._handleMoreMessageNotification
            );
        }

        if (this._device && this._device.gatt && this._device.gatt.connected) {
            this._device.gatt.disconnect();
        }

        this._server = null;
        this._officialChars = null;
        this._moreChars = null;
        this._mode = null;
        this._connected = false;
    }

    isUsbMicrobitConnected () {
        return Boolean(
            this._connected &&
            this._mode === 'usb' &&
            this._usbMicrobit.ready &&
            this._usbMicrobit.target
        );
    }

    hasUsbMicrobitFirmwareHint () {
        return this._hasUsbMicrobitFirmwareHint();
    }

    async installOfficialUsbFirmware (driveHandle) {
        if (!driveHandle) {
            throw new Error('VÃ¦lg MICROBIT-drevet fÃ¸rst');
        }

        try {
            const hasPermission = await this._ensureUsbMicrobitDrivePermission(driveHandle);
            if (!hasPermission) {
                throw new Error('Databygger fik ikke adgang til MICROBIT-drevet.');
            }
            if (!await this._looksLikeMicrobitDrive(driveHandle)) {
                throw new Error('VÃ¦lg selve MICROBIT-drevet, ikke en almindelig mappe.');
            }
            this._usbMicrobit.driveHandle = driveHandle;
            await this._installUsbMicrobitFirmwareToDriveHandle(driveHandle);
            this._setUsbMicrobitFirmwareHint(true);
            this._hideConnectionProgress();
        } catch (error) {
            this._hideConnectionProgress();
            throw error;
        }
    }

    async connectOfficialUsbPort (port) {
        if (!port) {
            throw new Error('VÃ¦lg micro:bit-serieporten fÃ¸rst');
        }

        try {
            await this._connectUsbMicrobitWithAuthorizedPort(port);
        } catch (error) {
            await this._disconnectUsbMicrobitSilently();
            this._hideConnectionProgress();
            throw error;
        }
    }

    async installOfficialUsbFirmware () {
        const usb = getNavigatorUsb();
        if (!usb) {
            throw new Error('WebUSB er ikke tilgÃ¦ngelig i denne browser.');
        }

        try {
            const device = await this._getAuthorizedOrRequestUsbDevice(
                usb,
                'VÃ¦lg din Micro:bit i nÃ¦ste vindue for at overfÃ¸re firmware direkte...'
            );
            if (!device) {
                return;
            }

            await this._installUsbMicrobitFirmwareWithDevice(device);
            this._setUsbMicrobitFirmwareHint(true);
            this._hideConnectionProgress();
        } catch (error) {
            this._hideConnectionProgress();
            if (error && error.message === 'Flash error') {
                throw new Error('Direkte USB-flash blev afvist af micro:bit. Hvis det fortsÃ¦tter efter denne opdatering, skal micro:bit interface-firmwaren opdateres til mindst 0249 (V1) eller 0255 (V2).');
            }
            throw error;
        }
    }

    async installOfficialUsbFirmwareViaDrive (driveHandle) {
        if (!driveHandle) {
            throw new Error('VÃ¦lg MICROBIT-drevet fÃ¸rst');
        }

        const hasPermission = await this._ensureUsbMicrobitDrivePermission(driveHandle);
        if (!hasPermission) {
            throw new Error('Databygger fik ikke adgang til MICROBIT-drevet.');
        }
        if (!await this._looksLikeMicrobitDrive(driveHandle)) {
            throw new Error('VÃ¦lg selve MICROBIT-drevet, ikke en almindelig mappe.');
        }

        this._usbMicrobit.driveHandle = driveHandle;
        await this._installUsbMicrobitFirmwareToDriveHandle(driveHandle);
        this._setUsbMicrobitFirmwareHint(true);
        this._hideConnectionProgress();
    }

    _matchesUsbMicrobitSerialPort (port) {
        if (!port || typeof port.getInfo !== 'function') {
            return false;
        }
        const info = port.getInfo() || {};
        return info.usbVendorId === RADIO_GATEWAY_VENDOR_ID;
    }

    _hasUsbMicrobitFirmwareHint () {
        const storage = getLocalStorage();
        return Boolean(storage && storage.getItem(USB_MICROBIT_FIRMWARE_HINT_KEY) === '1');
    }

    _setUsbMicrobitFirmwareHint (installed) {
        const storage = getLocalStorage();
        if (!storage) {
            return;
        }
        if (installed) {
            storage.setItem(USB_MICROBIT_FIRMWARE_HINT_KEY, '1');
        } else {
            storage.removeItem(USB_MICROBIT_FIRMWARE_HINT_KEY);
        }
    }

    async _ensureUsbMicrobitConnected () {
        if (this.isUsbMicrobitConnected()) {
            return;
        }
        if (this._usbMicrobit.connectPromise) {
            return this._usbMicrobit.connectPromise;
        }

        const serial = getNavigatorSerial();
        if (!serial) {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Web Serial er ikke tilgÃ¦ngelig i denne browser'
            });
            return;
        }

        const usb = getNavigatorUsb();
        this._usbMicrobit.connectPromise = this._connectUsbMicrobit({
            serial,
            usb
        }).finally(() => {
            this._usbMicrobit.connectPromise = null;
        });
        return this._usbMicrobit.connectPromise;
    }

    async _connectUsbMicrobit ({serial, usb}) {
        try {
            const rememberedPorts = typeof serial.getPorts === 'function' ?
                (await serial.getPorts()).filter(port => this._matchesUsbMicrobitSerialPort(port)) :
                [];

            if (!rememberedPorts.length && !this._hasUsbMicrobitFirmwareHint()) {
                if (!usb) {
                    throw new Error('Denne browser understÃ¸tter ikke WebUSB-firmwareoverfÃ¸rsel til micro:bit');
                }

                const device = await this._getAuthorizedOrRequestUsbDevice(
                    usb,
                    'VÃ¦lg din Micro:bit i nÃ¦ste vindue for at installere USB-firmwaren...'
                );
                if (!device) {
                    return;
                }

                await this._installUsbMicrobitFirmwareWithDevice(device);
                this._setUsbMicrobitFirmwareHint(true);
                this._hideConnectionProgress();
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Firmware er kopieret til MICROBIT-drevet. Vent til micro:bit er fÃ¦rdig med at genstarte, og tryk derefter "Forbind Micro:bit" igen for at Ã¥bne kabel-forbindelsen.'
                });
                return;
            }

            const port = rememberedPorts[0] || await this._requestUsbMicrobitSerialPort(serial);
            if (!port) {
                return;
            }

            await this._connectUsbMicrobitWithAuthorizedPort(port);
        } catch (error) {
            const message = error && error.message ? error.message : error;
            if (error && (error.name === 'AbortError' || error.name === 'NotFoundError')) {
                this._hideConnectionProgress();
                return;
            }

            log.error(`micro:bit usb serial connect error: ${message}`);
            await this._disconnectUsbMicrobitSilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: `Kunne ikke forbinde til Micro:bit over USB: ${message}`
            });
        }
    }

    async _ensureUsbMicrobitConnected () {
        if (this.isUsbMicrobitConnected()) {
            return;
        }
        if (this._usbMicrobit.connectPromise) {
            return this._usbMicrobit.connectPromise;
        }

        const serial = getNavigatorSerial();
        if (!serial) {
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: 'Web Serial er ikke tilgÃ¦ngelig i denne browser'
            });
            return;
        }

        this._usbMicrobit.connectPromise = this._connectUsbMicrobit({
            serial,
            usb: getNavigatorUsb()
        }).finally(() => {
            this._usbMicrobit.connectPromise = null;
        });
        return this._usbMicrobit.connectPromise;
    }

    async _connectUsbMicrobit ({serial, usb}) {
        try {
            const rememberedPorts = typeof serial.getPorts === 'function' ?
                (await serial.getPorts()).filter(port => this._matchesUsbMicrobitSerialPort(port)) :
                [];

            if (!rememberedPorts.length && !this._hasUsbMicrobitFirmwareHint()) {
                if (!usb) {
                    throw new Error('Denne browser understÃ¸tter ikke WebUSB-firmwareoverfÃ¸rsel til micro:bit');
                }

                const device = await this._getAuthorizedOrRequestUsbDevice(
                    usb,
                    'VÃ¦lg din Micro:bit i nÃ¦ste vindue for at installere USB-firmwaren...'
                );
                if (!device) {
                    return;
                }

                await this._installUsbMicrobitFirmwareWithDevice(device);
                this._setUsbMicrobitFirmwareHint(true);
                this._hideConnectionProgress();
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Firmwaren er nu lagt direkte pÃ¥ Micro:bit via USB. Vent til micro:bit er fÃ¦rdig med at genstarte, og tryk derefter "Forbind Micro:bit" igen for at Ã¥bne kabel-forbindelsen.'
                });
                return;
            }

            const port = rememberedPorts[0] || await this._requestUsbMicrobitSerialPort(serial);
            if (!port) {
                return;
            }

            await this._connectUsbMicrobitWithAuthorizedPort(port);
        } catch (error) {
            const message = error && error.message ? error.message : error;
            if (error && (error.name === 'AbortError' || error.name === 'NotFoundError')) {
                this._hideConnectionProgress();
                return;
            }

            log.error(`micro:bit usb serial connect error: ${message}`);
            await this._disconnectUsbMicrobitSilently();
            this._hideConnectionProgress();
            this._runtime.emit(this._runtime.constructor.PERIPHERAL_REQUEST_ERROR, {
                extensionId: this._extensionId,
                message: `Kunne ikke forbinde til Micro:bit over USB: ${message}`
            });
        }
    }

    async _connectUsbMicrobitWithAuthorizedPort (port) {
        await this._disconnectUsbMicrobitSilently();
        const target = await this._openUsbMicrobitSerialTarget(port);
        this._showConnectionProgress('Forbinder Micro:bit', null, 'Starter Micro:bit via kabel...');
        const connected = await this._tryUsbMicrobitHandshake(target, 12, 500);

        if (!connected || !this._usbMicrobit.ready) {
            this._setUsbMicrobitFirmwareHint(false);
            throw new Error('Micro:bit svarede ikke over kabel. Tryk fÃ¸rst pÃ¥ "Installer firmware", og prÃ¸v derefter igen.');
        }

        this._setUsbMicrobitFirmwareHint(true);
        this._mode = 'usb';
        this._connected = true;
        this._hideConnectionProgress();
        this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTED);
    }

    async _installUsbMicrobitFirmwareWithDevice (device) {
        if (!device) {
            throw new Error('VÃ¦lg en Micro:bit fÃ¸rst');
        }

        let target = null;
        try {
            target = new DAPjs.DAPLink(new DAPjs.WebUSB(device));
            await target.connect();
            await this._flashUsbMicrobitFirmware(target, device);
        } finally {
            if (target) {
                try {
                    await target.disconnect();
                } catch (error) {
                    log.warn(`micro:bit usb firmware target disconnect failed: ${error && error.message ? error.message : error}`);
                }
            }
            if (device.opened) {
                try {
                    await device.close();
                } catch (error) {
                    log.warn(`micro:bit usb firmware device close failed: ${error && error.message ? error.message : error}`);
                }
            }
        }
    }

    async _installUsbMicrobitFirmwareViaDrive (directoryPicker) {
        const driveHandle = await this._getUsbMicrobitDriveHandle(directoryPicker);
        await this._installUsbMicrobitFirmwareToDriveHandle(driveHandle);
    }

    async _installUsbMicrobitFirmwareToDriveHandle (driveHandle) {
        const firmwareBuffer = await this._getUsbMicrobitFirmwareBuffer();
        if (!firmwareBuffer) {
            throw new Error('USB micro:bit firmware is missing');
        }

        this._showConnectionProgress('Forbinder Micro:bit', 0.2, 'Kopierer firmware til MICROBIT-drevet...');

        const fileHandle = await driveHandle.getFileHandle('scratch-microbit-usb.hex', {create: true});
        const writable = await fileHandle.createWritable();
        await writable.write(new Uint8Array(firmwareBuffer));
        await writable.close();

        this._showConnectionProgress('Forbinder Micro:bit', 0.8, 'Venter pÃ¥ at Micro:bit installerer firmwaren...');
        await new Promise(resolve => setTimeout(resolve, 4000));
    }

    async _getUsbMicrobitDriveHandle (directoryPicker) {
        if (this._usbMicrobit.driveHandle) {
            const stillValid = await this._ensureUsbMicrobitDrivePermission(this._usbMicrobit.driveHandle);
            if (stillValid) {
                return this._usbMicrobit.driveHandle;
            }
        }

        this._showConnectionProgress('Forbinder Micro:bit', null, 'VÃ¦lg MICROBIT-drevet for at installere firmware...');
        const driveHandle = await directoryPicker({mode: 'readwrite'});

        if (!await this._looksLikeMicrobitDrive(driveHandle)) {
            throw new Error('VÃ¦lg selve MICROBIT-drevet, ikke en almindelig mappe');
        }

        this._usbMicrobit.driveHandle = driveHandle;
        return driveHandle;
    }

    async _ensureUsbMicrobitDrivePermission (driveHandle) {
        if (!driveHandle) {
            return false;
        }

        if (typeof driveHandle.queryPermission !== 'function') {
            return true;
        }

        let permission = await driveHandle.queryPermission({mode: 'readwrite'});
        if (permission !== 'granted' && typeof driveHandle.requestPermission === 'function') {
            permission = await driveHandle.requestPermission({mode: 'readwrite'});
        }

        return permission === 'granted';
    }

    async _looksLikeMicrobitDrive (driveHandle) {
        const candidateFiles = ['DETAILS.TXT', 'MICROBIT.HTM', 'INDEX.HTM'];
        for (const fileName of candidateFiles) {
            try {
                await driveHandle.getFileHandle(fileName);
                return true;
            } catch (error) {
                // Try next marker file
            }
        }
        return false;
    }

    async _requestUsbMicrobitSerialPort (serial) {
        this._showConnectionProgress('Forbinder Micro:bit', null, 'Vælg Micro:bit-serieporten...');
        return serial.requestPort({
            filters: [{
                usbVendorId: RADIO_GATEWAY_VENDOR_ID
            }]
        });
    }

    async _openUsbMicrobitSerialTarget (port) {
        await port.open({baudRate: 115200});

        const reader = port.readable.getReader();
        const writer = port.writable.getWriter();
        const encoder = new TextEncoder();

        const target = {
            port,
            reader,
            writer,
            startSerialRead: async () => {},
            stopSerialRead: async () => {
                try {
                    await reader.cancel();
                } catch (error) {
                    log.warn(`micro:bit usb reader cancel failed: ${error && error.message ? error.message : error}`);
                }
            },
            disconnect: async () => {
                try {
                    writer.releaseLock();
                } catch (error) {
                    // Ignore releaseLock failures
                }
                try {
                    reader.releaseLock();
                } catch (error) {
                    // Ignore releaseLock failures
                }
                try {
                    await port.close();
                } catch (error) {
                    log.warn(`micro:bit usb port close failed: ${error && error.message ? error.message : error}`);
                }
            },
            serialWrite: data => writer.write(encoder.encode(data))
        };

        this._usbMicrobit.device = port;
        this._usbMicrobit.target = target;
        this._usbMicrobit.ready = false;
        this._usbMicrobit.buffer = '';
        this._usbMicrobit.disconnecting = false;
        this._usbMicrobit.readLoopPromise = this._readUsbMicrobitSerialLoop(port, reader);
        return target;
    }

    async _readUsbMicrobitSerialLoop (port, reader) {
        const decoder = new TextDecoder();

        try {
            while (!this._usbMicrobit.disconnecting && this._usbMicrobit.device === port) {
                const {value, done} = await reader.read();
                if (done) {
                    break;
                }
                if (value && value.length) {
                    this._handleUsbMicrobitSerialData(decoder.decode(value, {stream: true}));
                }
            }
        } catch (error) {
            if (!this._usbMicrobit.disconnecting) {
                log.warn(`micro:bit usb read loop failed: ${error && error.message ? error.message : error}`);
            }
        } finally {
            try {
                const tail = decoder.decode();
                if (tail) {
                    this._handleUsbMicrobitSerialData(tail);
                }
            } catch (error) {
                // Ignore decoder flush failures
            }

            const wasUnexpected = !this._usbMicrobit.disconnecting && this._usbMicrobit.device === port;

            try {
                reader.releaseLock();
            } catch (error) {
                // Ignore releaseLock failures
            }

            if (wasUnexpected) {
                this._usbMicrobit.ready = false;
                this._usbMicrobit.buffer = '';
                this._usbMicrobit.device = null;
                this._usbMicrobit.target = null;
                this._usbMicrobit.readLoopPromise = null;
                this._connected = false;
                this._mode = null;
                this._runtime.emit(this._runtime.constructor.PERIPHERAL_CONNECTION_LOST_ERROR, {
                    extensionId: this._extensionId,
                    message: 'Micro:bit USB-forbindelsen blev afbrudt'
                });
            }
        }
    }

    async _disconnectUsbMicrobitSilently () {
        const {device, target} = this._usbMicrobit;

        this._usbMicrobit.disconnecting = true;
        this._usbMicrobit.ready = false;
        this._usbMicrobit.buffer = '';

        if (target) {
            try {
                await target.stopSerialRead();
            } catch (error) {
                log.warn(`micro:bit usb stopSerialRead failed: ${error && error.message ? error.message : error}`);
            }

            if (target.writer) {
                try {
                    target.writer.releaseLock();
                } catch (error) {
                    // Ignore releaseLock failures
                }
            }
        }

        if (device && typeof device.close === 'function') {
            try {
                await device.close();
            } catch (error) {
                log.warn(`micro:bit usb device close failed: ${error && error.message ? error.message : error}`);
            }
        }

        this._usbMicrobit.device = null;
        this._usbMicrobit.target = null;
        this._usbMicrobit.readLoopPromise = null;
        this._usbMicrobit.disconnecting = false;
    }

    _checkPinState (pin) {
        return this._sensors.touchPins[pin];
    }
}

const MicroBitTiltDirection = {
    FRONT: 'front',
    BACK: 'back',
    LEFT: 'left',
    RIGHT: 'right',
    ANY: 'any'
};

const MicroBitGestures = {
    MOVED: 'moved',
    SHAKEN: 'shaken',
    JUMPED: 'jumped'
};

const MicroBitButtons = {
    A: 'A',
    B: 'B',
    ANY: 'any'
};

class Scratch3MicroBitBlocks {
    static get EXTENSION_NAME () {
        return 'micro:bit';
    }

    static get EXTENSION_ID () {
        return 'microbit';
    }

    static get TILT_THRESHOLD () {
        return 15;
    }

    get BUTTONS_MENU () {
        return [
            {text: 'A', value: MicroBitButtons.A},
            {text: 'B', value: MicroBitButtons.B},
            {
                text: formatMessage({
                    id: 'microbit.buttonsMenu.any',
                    default: 'any',
                    description: 'label for "any" element in button picker for micro:bit extension'
                }),
                value: MicroBitButtons.ANY
            }
        ];
    }

    get GESTURES_MENU () {
        return [
            {text: formatMessage({id: 'microbit.gesturesMenu.moved', default: 'moved'}), value: MicroBitGestures.MOVED},
            {text: formatMessage({id: 'microbit.gesturesMenu.shaken', default: 'shaken'}), value: MicroBitGestures.SHAKEN},
            {text: formatMessage({id: 'microbit.gesturesMenu.jumped', default: 'jumped'}), value: MicroBitGestures.JUMPED}
        ];
    }

    get TILT_DIRECTION_MENU () {
        return [
            {text: formatMessage({id: 'microbit.tiltDirectionMenu.front', default: 'front'}), value: MicroBitTiltDirection.FRONT},
            {text: formatMessage({id: 'microbit.tiltDirectionMenu.back', default: 'back'}), value: MicroBitTiltDirection.BACK},
            {text: formatMessage({id: 'microbit.tiltDirectionMenu.left', default: 'left'}), value: MicroBitTiltDirection.LEFT},
            {text: formatMessage({id: 'microbit.tiltDirectionMenu.right', default: 'right'}), value: MicroBitTiltDirection.RIGHT}
        ];
    }

    get TILT_DIRECTION_ANY_MENU () {
        return this.TILT_DIRECTION_MENU.concat([{
            text: formatMessage({id: 'microbit.tiltDirectionMenu.any', default: 'any'}),
            value: MicroBitTiltDirection.ANY
        }]);
    }

    constructor (runtime) {
        this.runtime = runtime;
        this._peripheral = new MicroBit(this.runtime, Scratch3MicroBitBlocks.EXTENSION_ID);
    }

    getInfo () {
        return {
            id: Scratch3MicroBitBlocks.EXTENSION_ID,
            name: Scratch3MicroBitBlocks.EXTENSION_NAME,
            blockIconURI,
            menuIconURI,
            showStatusButton: true,
            blocks: [
                {
                    opcode: 'whenButtonPressed',
                    text: formatMessage({id: 'microbit.whenButtonPressed', default: 'when [BTN] button pressed'}),
                    blockType: BlockType.HAT,
                    arguments: {
                        BTN: {type: ArgumentType.STRING, menu: 'buttons', defaultValue: MicroBitButtons.A}
                    }
                },
                {
                    opcode: 'isButtonPressed',
                    text: formatMessage({id: 'microbit.isButtonPressed', default: '[BTN] button pressed?'}),
                    blockType: BlockType.BOOLEAN,
                    arguments: {
                        BTN: {type: ArgumentType.STRING, menu: 'buttons', defaultValue: MicroBitButtons.A}
                    }
                },
                '---',
                {
                    opcode: 'whenGesture',
                    text: formatMessage({id: 'microbit.whenGesture', default: 'when [GESTURE]'}),
                    blockType: BlockType.HAT,
                    arguments: {
                        GESTURE: {type: ArgumentType.STRING, menu: 'gestures', defaultValue: MicroBitGestures.MOVED}
                    }
                },
                '---',
                {
                    opcode: 'displaySymbol',
                    text: formatMessage({id: 'microbit.displaySymbol', default: 'display [MATRIX]'}),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        MATRIX: {type: ArgumentType.MATRIX, defaultValue: '0101010101100010101000100'}
                    }
                },
                {
                    opcode: 'displayText',
                    text: formatMessage({id: 'microbit.displayText', default: 'display text [TEXT]'}),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TEXT: {type: ArgumentType.STRING, defaultValue: 'Hello!'}
                    }
                },
                {
                    opcode: 'displayNumber',
                    text: 'vis nummer [NUM]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        NUM: {type: ArgumentType.NUMBER, defaultValue: 123}
                    }
                },
                {
                    opcode: 'displayClear',
                    text: formatMessage({id: 'microbit.clearDisplay', default: 'clear display'}),
                    blockType: BlockType.COMMAND
                },
                '---',
                {
                    opcode: 'whenTilted',
                    text: formatMessage({id: 'microbit.whenTilted', default: 'when tilted [DIRECTION]'}),
                    blockType: BlockType.HAT,
                    arguments: {
                        DIRECTION: {type: ArgumentType.STRING, menu: 'tiltDirectionAny', defaultValue: MicroBitTiltDirection.ANY}
                    }
                },
                {
                    opcode: 'isTilted',
                    text: formatMessage({id: 'microbit.isTilted', default: 'tilted [DIRECTION]?'}),
                    blockType: BlockType.BOOLEAN,
                    arguments: {
                        DIRECTION: {type: ArgumentType.STRING, menu: 'tiltDirectionAny', defaultValue: MicroBitTiltDirection.ANY}
                    }
                },
                {
                    opcode: 'getTiltAngle',
                    text: formatMessage({id: 'microbit.tiltAngle', default: 'tilt angle [DIRECTION]'}),
                    blockType: BlockType.REPORTER,
                    arguments: {
                        DIRECTION: {type: ArgumentType.STRING, menu: 'tiltDirection', defaultValue: MicroBitTiltDirection.FRONT}
                    }
                },
                '---',
                {
                    opcode: 'whenPinConnected',
                    text: formatMessage({id: 'microbit.whenPinConnected', default: 'when pin [PIN] connected'}),
                    blockType: BlockType.HAT,
                    arguments: {
                        PIN: {type: ArgumentType.STRING, menu: 'touchPins', defaultValue: '0'}
                    }
                },
                {
                    opcode: 'getTemperature',
                    text: 'temperatur',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getLightLevel',
                    text: 'lysniveau',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getSoundLevel',
                    text: 'lydniveau (kun V2)',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getAccelerationX',
                    text: 'acceleration X',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getAccelerationY',
                    text: 'acceleration Y',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getAccelerationZ',
                    text: 'acceleration Z',
                    blockType: BlockType.REPORTER
                },
                '---',
                {
                    opcode: 'setRadioGroup',
                    text: 'sæt radiogruppe til [GROUP]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        GROUP: {type: ArgumentType.NUMBER, defaultValue: 7}
                    }
                },
                {
                    opcode: 'sendRadioText',
                    text: 'send radiotekst [TEXT]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TEXT: {type: ArgumentType.STRING, defaultValue: 'hello'}
                    }
                },
                {
                    opcode: 'sendRadioNumber',
                    text: 'send radionummer [VALUE]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        VALUE: {type: ArgumentType.NUMBER, defaultValue: 1}
                    }
                },
                {
                    opcode: 'whenRadioReceived',
                    text: 'når radio modtages',
                    blockType: BlockType.HAT
                },
                {
                    opcode: 'lastRadioText',
                    text: 'seneste radiotekst',
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'lastRadioNumber',
                    text: 'seneste radionummer',
                    blockType: BlockType.REPORTER
                }
            ],
            menus: {
                buttons: {acceptReporters: true, items: this.BUTTONS_MENU},
                gestures: {acceptReporters: true, items: this.GESTURES_MENU},
                tiltDirection: {acceptReporters: true, items: this.TILT_DIRECTION_MENU},
                tiltDirectionAny: {acceptReporters: true, items: this.TILT_DIRECTION_ANY_MENU},
                touchPins: {acceptReporters: true, items: ['0', '1', '2']}
            }
        };
    }

    whenButtonPressed (args) {
        if (args.BTN === MicroBitButtons.ANY) {
            return this._peripheral.buttonA | this._peripheral.buttonB;
        }
        if (args.BTN === MicroBitButtons.A) {
            return this._peripheral.buttonA;
        }
        if (args.BTN === MicroBitButtons.B) {
            return this._peripheral.buttonB;
        }
        return false;
    }

    isButtonPressed (args) {
        return Boolean(this.whenButtonPressed(args));
    }

    whenGesture (args) {
        const gesture = cast.toString(args.GESTURE);
        if (gesture === MicroBitGestures.MOVED) {
            return (this._peripheral.gestureState >> 2) & 1;
        }
        if (gesture === MicroBitGestures.SHAKEN) {
            return this._peripheral.gestureState & 1;
        }
        if (gesture === MicroBitGestures.JUMPED) {
            return (this._peripheral.gestureState >> 1) & 1;
        }
        return false;
    }

    displaySymbol (args) {
        const symbol = cast.toString(args.MATRIX).replace(/\s/g, '');
        const reducer = (accumulator, c, index) => ((c === '0') ? accumulator : accumulator + Math.pow(2, index));
        const hex = symbol.split('').reduce(reducer, 0);
        if (hex !== null) {
            this._peripheral.ledMatrixState[0] = hex & 0x1F;
            this._peripheral.ledMatrixState[1] = (hex >> 5) & 0x1F;
            this._peripheral.ledMatrixState[2] = (hex >> 10) & 0x1F;
            this._peripheral.ledMatrixState[3] = (hex >> 15) & 0x1F;
            this._peripheral.ledMatrixState[4] = (hex >> 20) & 0x1F;
            this._peripheral.displayMatrix(this._peripheral.ledMatrixState);
        }
        return new Promise(resolve => setTimeout(resolve, BLESendInterval));
    }

    displayText (args) {
        const text = String(args.TEXT).substring(0, 19);
        if (text.length > 0) this._peripheral.displayText(text);
        const yieldDelay = 120 * ((6 * text.length) + 6);
        return new Promise(resolve => setTimeout(resolve, yieldDelay));
    }

    displayNumber (args) {
        const value = cast.toNumber(args.NUM);
        const text = String(value);
        this._peripheral.displayNumber(value);
        const yieldDelay = 120 * ((6 * text.length) + 6);
        return new Promise(resolve => setTimeout(resolve, yieldDelay));
    }

    displayClear () {
        for (let i = 0; i < 5; i++) {
            this._peripheral.ledMatrixState[i] = 0;
        }
        this._peripheral.displayMatrix(this._peripheral.ledMatrixState);
        return new Promise(resolve => setTimeout(resolve, BLESendInterval));
    }

    whenTilted (args) {
        return this._isTilted(args.DIRECTION);
    }

    isTilted (args) {
        return this._isTilted(args.DIRECTION);
    }

    getTiltAngle (args) {
        return this._getTiltAngle(args.DIRECTION);
    }

    whenPinConnected (args) {
        const pin = parseInt(args.PIN, 10);
        if (isNaN(pin) || pin < 0 || pin > 2) return false;
        return this._peripheral._checkPinState(pin);
    }

    getTemperature () {
        return this._peripheral.temperature;
    }

    getLightLevel () {
        return this._peripheral.lightLevel;
    }

    getSoundLevel () {
        this._peripheral.requestUsbMicrobitSoundLevel();
        return this._peripheral.soundLevel;
    }

    getAccelerationX () {
        return this._peripheral.accelerationX;
    }

    getAccelerationY () {
        return this._peripheral.accelerationY;
    }

    getAccelerationZ () {
        return this._peripheral.accelerationZ;
    }

    async setRadioGroup (args) {
        await this._peripheral.setRadioGroup(args.GROUP);
        return new Promise(resolve => setTimeout(resolve, BLESendInterval));
    }

    async sendRadioText (args) {
        await this._peripheral.sendRadioText(args.TEXT);
        return new Promise(resolve => setTimeout(resolve, BLESendInterval));
    }

    async sendRadioNumber (args) {
        await this._peripheral.sendRadioNumber(args.VALUE);
        return new Promise(resolve => setTimeout(resolve, BLESendInterval));
    }

    whenRadioReceived (args, util) {
        const oldSerial = util.stackFrame.lastRadioSerial || 0;
        if (this._peripheral.consumeRadioReceived(oldSerial)) {
            util.stackFrame.lastRadioSerial = this._peripheral._radio.serial;
            return true;
        }
        return false;
    }

    lastRadioText () {
        return this._peripheral.lastRadioText;
    }

    lastRadioNumber () {
        return this._peripheral.lastRadioNumber;
    }

    _isTilted (direction) {
        switch (direction) {
        case MicroBitTiltDirection.ANY:
            return (Math.abs(this._peripheral.tiltX / 10) >= Scratch3MicroBitBlocks.TILT_THRESHOLD) ||
                (Math.abs(this._peripheral.tiltY / 10) >= Scratch3MicroBitBlocks.TILT_THRESHOLD);
        default:
            return this._getTiltAngle(direction) >= Scratch3MicroBitBlocks.TILT_THRESHOLD;
        }
    }

    _getTiltAngle (direction) {
        switch (direction) {
        case MicroBitTiltDirection.FRONT:
            return Math.round(this._peripheral.tiltY / -10);
        case MicroBitTiltDirection.BACK:
            return Math.round(this._peripheral.tiltY / 10);
        case MicroBitTiltDirection.LEFT:
            return Math.round(this._peripheral.tiltX / -10);
        case MicroBitTiltDirection.RIGHT:
            return Math.round(this._peripheral.tiltX / 10);
        default:
            log.warn(`Unknown tilt direction in _getTiltAngle: ${direction}`);
            return 0;
        }
    }
}

module.exports = Scratch3MicroBitBlocks;


